<template>
    <div>
        <search-type></search-type>
        <search-title></search-title>
        <search-filter></search-filter>
        <property-results></property-results>
        <button
            v-show="showScrollTop"
            @click="scrollToTop"
            class="scroll-top-button"
            title="Voltar ao topo"
        >
            <i class="fas fa-arrow-up"></i>
        </button>
    </div>
</template>

<script>
import SearchType from './search-type.vue';
import SearchTitle from './search-title.vue';
import SearchFilter from './search-filter.vue';
import PropertyResults from './property-results.vue';
export default {
    components: { SearchType, SearchTitle, SearchFilter, PropertyResults },
    data() {
        return {
            showScrollTop: false
        }
    },
	props: {
        view: {
            type: String,
            required: true,
        },
		searchType: {
			type: String,
			required: true,
		},
		city: {
			type: Object,
			required: false,
		},
		state: {
			type: Object,
			required: false,
		},
		ads: {
			type: Array,
			required: true,
		},
		sponsoredAds: {
			type: Array,
			required: true,
		},
		district: {
			type: String,
			required: true,
		},
		pagination: {
			type: Object,
			required: true,
		},
		sort: {
			type: String,
			required: true,
		},
		filter: {
			type: Object|Array,
			required: true,
		},
		pageTitle: {
			type: String,
			required: true,
		},
	},
    created() {
        this.$store.commit('setView', this.view);
        this.$store.commit('setSearchType', this.searchType);
        this.$store.commit('setCity', this.city);
        this.$store.commit('setState', this.state);
        this.$store.commit('setAds', this.ads);
        this.$store.commit('setSponsoredAds', this.sponsoredAds);
        this.$store.commit('setPagination', this.pagination);
        this.$store.commit('setSort', this.sort);
        this.$store.commit('setFilter', this.filter);
        this.$store.commit('setPageTitle', this.pageTitle);
        this.$store.commit('setSelectedDistricts', this.district);

        if (this.ads.length >= this.pagination.per_page) {
            this.$store.commit('setButtonVisibility', true);
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        EventBus.$emit('close-beacon', 'beacon');
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.showScrollTop = window.scrollY > 300;
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.scroll-top-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #55748F;
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    transition: all 0.3s ease;
    z-index: 1000;

    &:hover {
        background-color: #52D298;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }

    i {
        font-size: 18px;
    }
}
</style>
